// VideoBand.jsx — desktop: full-bleed video w/ centered overlay.
// mobile: crafted dark editorial section with the film shown FULLY (uncropped)
// in a framed cinema strip below the statement.
import React from "react";
import { Reveal } from "./Primitives";
import LazyVideo from "./LazyVideo";
import { useIsMobile } from "./hooks";

export default function VideoBand({ src, eyebrow, title, subtext, height = "86vh", scrim, titleSize = "clamp(34px,5.4vw,76px)", testId }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <section data-testid={testId} style={{ background: "var(--ink)", color: "var(--paper)", padding: "clamp(60px,11vh,84px) 0" }}>
        <div style={{ padding: "0 24px", textAlign: "center", maxWidth: 560, margin: "0 auto" }}>
          {eyebrow && (
            <Reveal><span className="k-eye" style={{ color: "rgba(246,241,232,.72)", display: "block", marginBottom: 18 }}>{eyebrow}</span></Reveal>
          )}
          <Reveal delay={0.06}>
            <h2 className="k-display" style={{ fontSize: "clamp(29px,8.2vw,42px)", color: "var(--paper)", fontWeight: 400, lineHeight: 1.1, margin: 0, letterSpacing: "-.015em" }}>{title}</h2>
          </Reveal>
          {subtext && (
            <Reveal delay={0.12}><p style={{ color: "rgba(246,241,232,.8)", fontSize: 15.5, lineHeight: 1.6, marginTop: 18 }}>{subtext}</p></Reveal>
          )}
        </div>
        {/* film, fully visible */}
        <div style={{ position: "relative", margin: "30px 16px 0", aspectRatio: "16 / 9", borderRadius: 18, overflow: "hidden", border: "1px solid rgba(246,241,232,.16)", boxShadow: "0 24px 46px -26px rgba(0,0,0,.7)", background: "#15110d" }}>
          <LazyVideo src={src} fit="cover" radius={18} />
          <div style={{ position: "absolute", inset: 0, boxShadow: "inset 0 0 0 1px rgba(255,255,255,.08)", borderRadius: 18, pointerEvents: "none" }} />
        </div>
      </section>
    );
  }

  return (
    <section className="k-vid" style={{ minHeight: height, display: "flex", alignItems: "center", justifyContent: "center" }} data-testid={testId}>
      <LazyVideo src={src} fit="cover" />
      <div className="k-vid-scrim" style={{ background: scrim || "linear-gradient(180deg, rgba(16,14,12,.55), rgba(16,14,12,.42) 50%, rgba(16,14,12,.62))" }} />
      <div className="k-vid-inner" style={{ width: "100%", maxWidth: 980, padding: "90px clamp(24px,5vw,40px)", textAlign: "center" }}>
        {eyebrow && (
          <Reveal>
            <span className="k-eye" style={{ color: "rgba(255,255,255,.78)", display: "block", marginBottom: 22 }}>{eyebrow}</span>
          </Reveal>
        )}
        <Reveal delay={0.08}>
          <h2 className="k-display" style={{ fontSize: titleSize, color: "#fff", fontWeight: 400, lineHeight: 1.08, margin: 0, letterSpacing: "-.015em", textShadow: "0 2px 50px rgba(10,8,6,.45)" }}>{title}</h2>
        </Reveal>
        {subtext && (
          <Reveal delay={0.18}>
            <p style={{ color: "rgba(255,255,255,.85)", fontSize: "clamp(15px,1.6vw,19px)", lineHeight: 1.6, marginTop: 24, fontFamily: "var(--font-sans)", letterSpacing: ".01em" }}>{subtext}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
